import { useCallback, useState } from "react";

import type { DialogButton } from "@/components/ConfirmDialog";

interface DialogState {
    visible: boolean;
    title: string;
    message: string;
    buttons: DialogButton[];
}

export function useConfirmDialog() {
    const [state, setState] = useState<DialogState>({
        visible: false,
        title: "",
        message: "",
        buttons: []
    });

    const showDialog = useCallback((title: string, message: string, buttons?: DialogButton[]) => {
        setState({
            visible: true,
            title,
            message,
            buttons: buttons ?? [{ text: "OK" }]
        });
    }, []);

    const dismiss = useCallback(() => {
        setState((prev) => ({ ...prev, visible: false }));
    }, []);

    return { dialogState: state, showDialog, dismissDialog: dismiss };
}
